import {ServiceWorkerMiddleware} from 'go/src/atlas/edison_service_worker/service_worker/lib/service_worker_middleware/service_worker_middleware';
import {swActiveMiddleware} from 'go/src/atlas/edison_service_worker/service_worker/middlewares/sw_active';
import {HeartbeatManager} from 'go/src/atlas/edison_service_worker/service_worker/util/heartbeat';
import {
  initSentry,
  captureException,
} from 'go/src/atlas/edison_service_worker/service_worker/util/sentry';

declare const self: ServiceWorkerGlobalScope;

// Arbitrary version number for monitoring purposes
// Feel free to increment as needed
const VERSION = '1.0.0';

initSentry(self, VERSION);

const swMiddleware = new ServiceWorkerMiddleware({reportError: captureException});
const heartbeatManager = new HeartbeatManager(self, VERSION);

// **********************
// REGISTER MIDDLEWARES
// **********************

// Required middleware to ensure the Edison knows that the service worker is active
swMiddleware.useRequest(swActiveMiddleware(self));

// Example request middleware with feature flag
// Feel free to remove this
swMiddleware.useRequest(async (request, next) => {
  if (Math.random() < 0.1) {
    // eslint-disable-next-line no-console
    console.log('[Example middleware] randomly say hello!', request.url);
  }
  await next();
}, 'exampleSwFeature');

// **********************
// HANDLE EVENTS
// **********************

// Apply middleware to all fetch events
self.addEventListener('fetch', (event: FetchEvent) => {
  event.respondWith(swMiddleware.handleFetchEvent(event));
});

// Load feature flags on install
self.addEventListener('install', (event: ExtendableEvent) => {
  event.waitUntil(Promise.all([self.skipWaiting(), swMiddleware.loadFeatureFlags()]));
});

self.addEventListener('activate', (event: ExtendableEvent) => {
  event.waitUntil(self.clients.claim());
  heartbeatManager.startHeartbeat();
});

// Report unhandled errors to Sentry
self.addEventListener('error', (event: ErrorEvent) => {
  captureException(event.error);
});
self.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  captureException(event.reason);
});
